import { FilteredCreditApplication } from '@applyonline/shared'
import { EApplicantType, EDocumentStatus, EDocumentType, ERequiredFrom } from '@if/core/types'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequiredDocumentsWithStatus } from '../data/credit-application-hooks'
import RequiredDocumentTable from './RequiredDocumentTable'

interface Props {
  creditApp: FilteredCreditApplication
}
const UploadFilesTable = ({ creditApp }: Props): JSX.Element => {
  const reqDocList = useRequiredDocumentsWithStatus(creditApp.requiredDocuments, creditApp.documents)
  const applicantRequiredDocs = reqDocList.filter(
    (d) =>
      d.applicantType !== EApplicantType.CoApplicant &&
      d.typeId !== EDocumentType.SignedCVT &&
      d.status !== EDocumentStatus.Approved &&
      d.documentRequiredFrom == ERequiredFrom.Customer,
  )
  const { t } = useTranslation()

  const coApplicantRequiredDocs = reqDocList.filter(
    (d) =>
      d.applicantType === EApplicantType.CoApplicant &&
      d.status !== EDocumentStatus.Approved &&
      d.documentRequiredFrom == ERequiredFrom.Customer,
  )

  return (
    <div className="paragraph" id="paragraph-document">
      <h4 className="subtitle">{t('common.documents')}</h4>
      {applicantRequiredDocs.length > 0 && (
        <RequiredDocumentTable creditApp={creditApp} applicantType={EApplicantType.Applicant} />
      )}
      {creditApp.coapplicant && coApplicantRequiredDocs.length > 0 && (
        <RequiredDocumentTable creditApp={creditApp} applicantType={EApplicantType.CoApplicant} />
      )}
    </div>
  )
}

export default UploadFilesTable
